module.exports = __webpack_public_path__ + "static/media/ico_simulation_eyeheighttobrow.a3c6f3f0.png";